module.exports = __webpack_public_path__ + "img/button2.56edc091.png";